<template>
    <div class="image-gallery">
        <div class="image-gallery__active-wrapper">
            <ImageFluid
                :src="activeImage.large"
                :alt="activeImage.altText"
                class="image-gallery__active-image"
                width="750"
                height="550"
            />
            <div v-if="hasMultipleImages" class="image-gallery__actions">
                <slot name="prev" :click="showPrev">
                    <button class="image-gallery__button button-prev" @click.prevent="showPrev" title="vorheriges Foto">
                        <IconSvg filepath="gallery/prev.svg"></IconSvg>
                    </button>
                </slot>

                <slot name="next" :click="showNext">
                    <button class="image-gallery__button button-next" @click.prevent="showNext" title="nächstes Foto">
                        <IconSvg filepath="gallery/next.svg"></IconSvg>
                    </button>
                </slot>
            </div>
        </div>

        <div class="image-gallery__thumbnails" v-if="!hideThumbnails && hasMultipleImages">
            <div
                v-for="(image, imageIndex) in images"
                :key="'image' + imageIndex"
                @click="index = imageIndex"
                class="image-gallery__thumbnail"
                :class="{ 'image-gallery__thumbnail--active': index === imageIndex }"
            >
                <ImageFluid :src="image.small" :alt="image.altText" class="gallery-image" width="150" height="110" />
            </div>
        </div>
    </div>
</template>

<script>
import ImageFluid from '@/components/ImageFluid';

export default {
    name: 'ImageGallery',
    components: {
        ImageFluid
    },
    data() {
        return {
            index: 0
        };
    },
    props: {
        images: Array,
        hideThumbnails: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        activeImage() {
            return this.images[this.index];
        },
        hasMultipleImages() {
            return this.images.length > 1;
        }
    },
    methods: {
        showPrev() {
            this.index = this.index ? this.index - 1 : this.images.length - 1;
        },
        showNext() {
            this.index = (this.index + 1) % this.images.length;
        }
    }
};
</script>

<style lang="scss">
@use '@/styles/variables';
@use '@/styles/theming' as *;

.image-gallery {
    $grid-gap: 4px;

    &__active-wrapper {
        position: relative;
        margin-bottom: $grid-gap;
        padding-top: variables.$image-gallery-ratio;
        aspect-ratio: 15/11;
        overflow: hidden;
    }

    &__active-image {
        position: absolute;
        left: 0;
        top: 0;
    }

    &__button {
        @include themify {
            color: themed('$primary');
        }
        position: absolute;
        width: 40px;
        height: 40px;
        line-height: 40px;
        padding: 0;
        text-align: center;
        background-color: hsla(0, 0%, 100%, 0.9);
        z-index: 3;
        speak: none;
        box-shadow: 0 2px 14px 0 hsla(219, 42%, 41%, 0.32);
        border-radius: 50%;
        border-width: 0;
        cursor: pointer;

        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 18px;

        &:hover {
            background-color: hsla(0, 0%, 100%, 1);
        }

        &.button-prev {
            left: variables.$grid-padding;
            top: 50%;
            transform: translateY(-50%);
        }

        &.button-next {
            right: variables.$grid-padding;
            top: 50%;
            transform: translateY(-50%);
        }

        &:active,
        &:focus {
            outline: none;
        }
    }

    &__thumbnails {
        display: grid;
        grid-gap: $grid-gap;
        grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
    }

    &__thumbnail {
        position: relative;
        width: 100%;
        height: 80px;
        cursor: pointer;
        opacity: 0.5;
        transition: opacity 0.2s ease-in-out;

        &:hover,
        &--active {
            @include themify {
                outline: 2px solid themed('$primary');
            }
            opacity: 1;
        }
    }

    @include variables.ie {
        &__thumbnails {
            display: flex;
            flex-wrap: wrap;
            margin: 0 -2px;
        }

        &__thumbnail {
            flex: 0 1 118px;
            margin: 2px;
        }
    }
}
</style>
